import examService from '@/services/exam';

const state = {
  aiLevel: 1,
  sgf: null,
  userColor: 'black',
  boardSize: 9,
  capCount: {black: 0, white: 0},
  startAt: null,
  overGameCreatedTime: null,
  id: null,
  examId: null,
  lastMoveAt: null,
  time: null,
  byoYomiTime: null,
  byoYomiAmount: null,
  blackByoYomiAmount: null,
  blackByoYomiTime: null,
  blackTime: null,
  whiteByoYomiAmount: null,
  whiteByoYomiTime: null,
  whiteTime: null,
  isWin: null,
  winninyWay: null,
};

const getters = {};

const actions = {
  async createExamGame({commit}, gameData) {
    const result = await examService.createExamGame(gameData);
    commit('setGameData', result);
    return result;
  },
  async playerMove({state, commit}, {move, time, byoYomiTime, byoYomiAmount}) {
    const data = {
      examId: state.examId,
      gameId: state.id,
      boardMove: move,
      time,
      byoYomiTime,
      byoYomiAmount,
    };
    const result = await examService.setPlayerMove(data);
    commit('updateTime', result);
    return result;
  },
  async aiMove({state, commit}) {
    const data = {
      examId: state.examId,
      gameId: state.id,
    };
    const result = await examService.getAiMove(data);
    commit('updateTime', result);
    return result;
  },
  getJudgement({state}) {
    const data = {
      examId: state.examId,
      gameId: state.id,
    };
    return examService.getJudgement(data);
  },
  async confirmJudgement({state, commit}) {
    const data = {
      examId: state.examId,
      gameId: state.id,
    };
    const result = await examService.confirmJudgementResult(data);
    commit('updateTime', result);
    return result;
  },
  async cancelJudgement({state, commit}) {
    const data = {
      examId: state.examId,
      gameId: state.id,
    };
    const result = await examService.cancelJudgementResult(data);
    commit('updateTime', result);
    return result;
  },
  async resign({state, commit}, {time, byoYomiTime, byoYomiAmount}) {
    const data = {
      examId: state.examId,
      gameId: state.id,
      boardMove: 'resign',
      time,
      byoYomiTime,
      byoYomiAmount,
    };
    const result = await examService.setPlayerMove(data);
    commit('updateTime', result);
    return result;
  },
};
const mutations = {
  setExamId(state, value) {
    state.examId = value.examId;
  },
  overGameData(state) {
    state.overGameCreatedTime = state.createdTime;
    state.createdTime = null;
    state.sgf = null;
    state.supportCount = 0;
  },
  setGameData(state, game) {
    if (game) {
      state.sgf = game.sgf;
      state.userColor = game.userColor === 'B' ? 'black' : 'white';
      state.startAt = game.startAt;
      state.aiLevel = game.aiLevel;
      state.boardSize = game.boardSize;
      state.id = game.id;
      state.lastMoveAt = game.lastMoveAt;
      state.time = game.time;
      state.byoYomiTime = game.byoYomiTime;
      state.byoYomiAmount = game.byoYomiAmount;
      state.blackByoYomiAmount = game.blackByoYomiAmount;
      state.blackByoYomiTime = game.blackByoYomiTime;
      state.blackTime = game.blackTime;
      state.whiteByoYomiAmount = game.whiteByoYomiAmount;
      state.whiteByoYomiTime = game.whiteByoYomiTime;
      state.whiteTime = game.whiteTime;
      state.isWin = game.isWin;
      state.winninyWay = game.winninyWay;
    }
  },
  resetGameData(state) {
    state.sgf = null;
    state.userColor = 'black';
    state.startAt = null;
    state.aiLevel = 1;
    state.boardSize = 9;
    state.style = '';
    state.id = null;
    state.lastMoveAt = null;
    state.time = null;
    state.byoYomiTime = null;
    state.byoYomiAmount = null;
    state.blackTime = null;
    state.blackByoYomiTime = null;
    state.blackByoYomiAmount = null;
    state.whiteTime = null;
    state.whiteByoYomiTime = null;
    state.whiteByoYomiAmount = null;
    state.isWin = null;
    state.winninyWay = null;
  },
  setUserColor(state, color) {
    state.userColor = color > 0 ? 'black' : 'white'; // 1 or -1;
  },
  setSgf(state, sgf) {
    if (state.createdTime) {
      state.sgf = sgf;
    }
  },
  setCapCount(state, capCount) {
    state.capCount = capCount;
  },
  setBoardSize(state, size) {
    state.boardSize = size;
  },
  updateTime(state, data) {
    state.blackTime = data.blackTime;
    state.blackByoYomiTime = data.blackByoYomiTime;
    state.blackByoYomiAmount = data.blackByoYomiAmount;
    state.whiteTime = data.whiteTime;
    state.whiteByoYomiTime = data.whiteByoYomiTime;
    state.whiteByoYomiAmount = data.whiteByoYomiAmount;
    state.sgf = data.sgf;
    state.lastMoveAt = data.lastMoveAt;
    state.turnColor = data.turnColor;
    state.isWin = data.isWin;
    state.winninyWay = data.winninyWay;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
